module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/other-68e3e57720297b778f8c6bb5188dfc09.png";